import axios from 'axios';

const apiUrl = process.env.REACT_APP_BACKEND_URL;

// Axios instance with common config
const apiClient = axios.create({
    baseURL: apiUrl, // 공통 baseURL 설정
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request interceptor to add auth token to headers
apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('authToken');
        if (token) {
            config.headers['Authorization'] = `${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);


// 응답 후 인터셉터 (에러 처리)
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            console.error('Unauthorized - Redirect to login');
        }
        return Promise.reject(error);
    }
);

export default apiClient;
